import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './shared/tokens/tokens.css';
import './shared/tokens/vendor-dell.css';
import './shared/tokens/vendor-smc.css';
import reportWebVitals from './reportWebVitals';
import '@aws-amplify/ui-react/styles.css';
import { Amplify } from 'aws-amplify'
import config from './aws-exports'
import amplifyConfig from './amplifyconfiguration.json'
import { ThemeProvider } from '@aws-amplify/ui-react'
import App from './App';

// On Gen2 branches, App.js already configures Amplify with the Gen2 amplify_outputs
// (nested `auth{}`). Only fall back to the Gen1 aws-exports config when no Gen2 config
// is present, so we don't override App.js's Gen2 configure and break OAuth redirect matching.
if (!amplifyConfig?.auth) {
  Amplify.configure(config)
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(log) with the devLog helper)
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
